import { environment } from './../../environments/environment'

export const UiSettings = {
    dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
    dateFormat: 'YYYY-MM-DD',
    timeFormat: 'HH:mm:ss',
    environment: environment,
    defaultSmartTableSettings: {
        mode: 'external',
        hideSubHeader: true,
        actions: {
            position: 'right',
            columnTitle: '',
            delete: false,
            edit: true,
        },
        edit: {
            editButtonContent: '<div class="btn btn-xs btn-primary btn-rectangle">Edit</div>',
            saveButtonContent: '<div class="btn btn-xs btn-primary btn-rectangle">Save</div>',
            cancelButtonContent: '<div class="btn btn-xs btn-primary btn-rectangle">Cancel</div>',
        },
        noDataMessage: 'Loading...',
        noDataMessageRealOne: 'No data found'
    }
};



// WEBPACK FOOTER //
// ./src/app/common/ui-settings.ts